import gql from 'graphql-tag';

export default gql`
  mutation (
    $contentGroupId: MongoID!
    $status: Boolean
    $name: String
    $description: String
    $timestatus: String
    $certificatetime: Date
    $typesign: String
    $firstname: String
    $lastname: String
    $signatureURL: String
    $position: String
    $logoURL: String
    $backgroundURL: String
  ) {
    updateContentGroupCertificateTemplate(
      contentGroupId: $contentGroupId
      status: $status
      name: $name
      description: $description
      timestatus: $timestatus
      certificatetime: $certificatetime
      typesign: $typesign
      firstname: $firstname
      lastname: $lastname
      signatureURL: $signatureURL
      position: $position
      logoURL: $logoURL
      backgroundURL: $backgroundURL
    ) {
      _id
      certificateconfig {
        status
        name
        description
      }
    }
  }
`;
